export enum GoogleSiteDetailsNameEnum {
  AREA_NAME_ASC = 'Area Name: A-Z',
  AREA_NAME_DESC = 'Area Name: Z-A',
  LAST_COPIED_DATE_ASC = 'Last Copied Date: Asc',
  LAST_COPIED_DATE_DESC = 'Last Copied Date: Desc',
}
